'use client';
import {
  FC,
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';

type CreateListModalContextProps = {
  openModal: () => void;
  closeModal: () => void;
  setModal: (setModal: boolean) => void;
  showModal: boolean;
};

const CreateListModalContext = createContext<CreateListModalContextProps>(null);

export const useCreateListModal = () => useContext(CreateListModalContext);

export const CreateListModalProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const setModal = useCallback((shouldOpen: boolean) => {
    setIsModalOpen(shouldOpen);
  }, []);

  const createListModalContext = useMemo(
    () => ({
      openModal,
      closeModal,
      setModal,
      showModal: Boolean(isModalOpen)
    }),
    [openModal, closeModal, setModal, isModalOpen]
  );

  return (
    <CreateListModalContext.Provider value={createListModalContext}>
      {children}
    </CreateListModalContext.Provider>
  );
};
